import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import styles from '../../styles/Pagination.module.css'

const Pagination = (props: { page: number, pages: number, onPageClick: any }) => {

  const paginator = (
    currentPageNumber: number,
    totalPageNumber: number,
    offset = 2
  ): string[] => {
    const offsetNumber =
      currentPageNumber <= offset || currentPageNumber > totalPageNumber - offset ? offset : offset - 1;
    const numbersList: number[] = [];
    const numbersListWithDots: any = [];
    if (totalPageNumber <= 1 || totalPageNumber === undefined) return ['1'];
    numbersList.push(1);
    for (let i = currentPageNumber - offsetNumber; i <= currentPageNumber + offsetNumber; i++) {
      if (i < totalPageNumber && i > 1) {
        numbersList.push(i);
      }
    }
    numbersList.push(totalPageNumber);
    numbersList.reduce((accumulator, currentValue) => {
      if (accumulator === 1) {
        numbersListWithDots.push(accumulator);
      }
      if (currentValue - accumulator !== 1) {
        numbersListWithDots.push('...');
      }
      numbersListWithDots.push(currentValue);

      return currentValue;
    });
    return numbersListWithDots.map((item: any) => item.toString());
  }

  if (props.pages <= 1) return <></>

  return(
    <div className={[styles.container, 'd-flex justify-content-center align-items-center gap-4'].join(' ')}>
      <FontAwesomeIcon
        icon={faChevronLeft}
        className={[(props.page <= 1 ? styles.inactive : ''), 'clickable'].join(' ')}
        onClick={() => props.onPageClick(props.page - 1)}
      />
      {paginator(props.page, props.pages).map((item: string, index) => (
        <div
          className={[(parseInt(item) === props.page ? styles.active : ''), (item !== '...' ? 'clickable' : '')].join(' ')}
          key={index + 1}
          onClick={item !== '...' ? (() => props.onPageClick(parseInt(item))) : (() => {})}
        >
          {item}
        </div>
      ))}
      <FontAwesomeIcon
        icon={faChevronRight}
        className={[(props.page === props.pages ? styles.inactive : ''), 'clickable'].join(' ')}
        onClick={() => props.onPageClick(props.page + 1)}
      />
    </div>
  )
}

export default Pagination